<template functional>
	<!-- Full width of the screen -->
	<div class="xs-12 flex xs-center wrap p4 md-pt2 md-p8 pb10">
		<!-- Possible limits based on props -->
		<div
			:class="[
				{ small: props.small },
				{ medium: props.medium },
				{ large: props.large },
				{ full: props.full }
			]"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	functional: true,
	props: {
		small: { type: Boolean, default: false },
		medium: { type: Boolean, default: false },
		large: { type: Boolean, default: false },
		full: { type: Boolean, default: false }
	}
}
</script>
<style scoped>
@import "../../../assets/css/tokens.css";

.small {
	width: 100%;
	max-width: var(--maxWidth5);
}

.medium {
	width: 100%;
	max-width: var(--maxWidth6);
}

.large {
	width: 100%;
	max-width: var(--maxWidth2);
}

.full {
	width: 100%;
}
</style>
